import { createStore } from "vuex";
import auth from "@emcd-shared/auth-service/store";
import coins from "@emcd/common/utils/coins";
import coinService from "@emcd-shared/coin-service";
import ui from "./ui.store";
import user from "./user.store";
import wallets from "./wallets.store";
import explorer from "./explorer";
import alerts from "./alerts";
import rwa from "./rwa";
const store = createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    coins,
    coinService,
    ui,
    user,
    wallets,
    explorer,
    rwa,
    alerts,
  },
});

export { store };
